'use client';
import cn from 'classnames';

import './EllaPrompt.style.scss';
import { EllaPromptObject } from '@/types/Ella';

type EllaPromptProps = {
  className?: string;
  largePrompt?: boolean;
  prompt: EllaPromptObject;
  onClick?: (e: any) => void;
};

function EllaPrompt(props: EllaPromptProps) {
  const { prompt, className = '', onClick, largePrompt = false } = props;

  const promptWithoutLastWord = prompt.prompt.split(' ').slice(0, -1).join(' ');
  const lastWordOfPrompt = prompt.prompt.split(' ').slice(-1).join(' ');

  return (
    <button
      className={cn('EllaPrompt', className, { largePrompt })}
      onClick={(e) => {
        onClick?.(e);
      }}
    >
      {/* Prevent last word from being orphaned */}
      {promptWithoutLastWord}
      &nbsp;
      {lastWordOfPrompt}
    </button>
  );
}

export default EllaPrompt;
